import Vue from 'vue'
import Router from 'vue-router'


// Auth & User
import Login from '@/views/auth/Login.vue'
import Logout from '@/views/auth/Logout.vue'
// Initiate process
import Register from '@/views/auth/Register.vue'
import RequestReset from '@/views/auth/RequestReset.vue'
// Handle e-mail links
import ConfirmRecover from '@/views/auth/ConfirmRecover.vue'
import ConfirmInvite from '@/views/auth/ConfirmInvite.vue'
import ConfirmEmailChange from '@/views/auth/ConfirmEmailChange.vue'
import ConfirmRegistration from '@/views/auth/ConfirmRegistration.vue'

// Auth admin
import NetlifyIdentityAdmin from '@/views/NetlifyIdentityAdmin.vue'

// Neighborhood information
import Graphs from '@/views/Graphs.vue'
import Introduction from '@/views/Introduction.vue'

// Filters
import Filters from '@/views/Filters.vue'

// 404
import NotFound from '@/views/NotFound.vue'

// Map
import Map from '@/views/Map'

import { isLoggedIn } from '@/services/auth'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    
    // Authentication, etc.
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        layout: 'login',
        public: true
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      meta: {
        profile: true
      }
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        layout: 'login',
        public: true
      }
    },
    {
      path: '/recover',
      name: 'recover',
      component: ConfirmRecover,
      meta: {
        layout: 'login',
        public: true
      }
    },
    {
      path: '/reset',
      name: 'request-reset',
      component: RequestReset,
      meta: {
        layout: 'login',
        public: true
      }
    },
    {
      path: '/invite',
      name: 'invite',
      component: ConfirmInvite,
      meta: {
        layout: 'login',
        public: true
      }
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: ConfirmRegistration,
      meta: {
        layout: 'login',
        public: true
      }
    },
    {
      path: '/confirm-email',
      name: 'confirm-email',
      component: ConfirmEmailChange,
      meta: {
        layout: 'login',
        public: true
      }
    },

    // Authentication admin - Netlify Identify Widget
    {
      path: '/users',
      name: 'netlify-identity-admin',
      component: NetlifyIdentityAdmin
    },

    // Map
    {
      path: '/',
      name: 'home',
      component: Map,
      meta: {
        layout: 'map'
      }
    },

    {
      path: '/informatie',
      name: 'introduction',
      component: Introduction,
      meta: {
        sidebar: 'introduction'
      }
    },

    // Neighborhood information
    {
      path: '/buurt-informatie/:slug?',
      name: 'neighborhood-information',
      component: Graphs
    },

    // Filters
    {
      path: '/filters',
      name: 'filters',
      component: Filters,
      meta: {
        sidebar: 'barcode'
      }
    },


    // 404
    {
      path: '/not-found',
      name: 'not-found',
      component: NotFound
    },
    {
      path: '/*',
      name: '404',
      component: NotFound,
      meta: {
        layout: 'login',
        public: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // Public pages
  if (to.meta && to.meta.public) {
    next()
  } else if (isLoggedIn()) {
    next()
  } else {
    next({ name: 'login' })
  }
})

export default router;
